import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import ScoreProxy from './ScoreProxy'

class ScoreService extends ServiceBase {
  getCreditRiskScore(params) {
    return this.getData(() => ScoreProxy.getCreditRiskScore(params))
  }
  getPerformanceScore(params) {
    return this.getData(() => ScoreProxy.getPerformanceScore(params))
  }
}

export default new ScoreService()
